import React, { useEffect, useState, useCallback, useMemo, useRef } from "react";
import { inject, observer } from "mobx-react";
import { getFormatedContact, validAusNumberRegExpDeluxe } from "constant/messageConstants";
import { toJS } from "mobx";
import { debounceTime } from "constant/constant";
import debounce from "lodash.debounce";
import FormInput from "components/FormItems/FormInput";
import { List, Popover, Tag } from "antd";
import { isEmpty } from "lodash";

const ContactSelector = ({
  contactStore,
  size = "default",
  label,
  containerProps,
  name,
  mode = "tags",
  placeholder = "Enter mobile numbers",
  errors = {},
  touched = {},
  values = {},
  onChange,
  secondary,
  onDeselect,
  setFieldValue,
  modalStore,
  isTestSms = false,
  containerClassname = "",
  inputClassname = "",
  inputStyle = {},
  filterContactBy = name,
  contactDataField = "numberList"
}) => {
  const inputRef = useRef();

  const { getContactBySearch, setSearchContacts, searchedContact } = contactStore;
  const [searchValue, setSearchValue] = useState("");
  const [options, setOptions] = useState([]);
  const [value, setValue] = useState("");
  const [tempValues, setTempValues] = useState([]);
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);

  const debouncedSave = useCallback(
    debounce(nextValue => setSearchValue(nextValue), debounceTime),
    []
  );

  useEffect(() => {
    const handleClickOutside = event => {
      if (!((event.target.id !== "popover-select-menu") ^ (event.target.id !== "popover-select-item"))) {
        setVisible(false);
      }
    };
    if (inputRef.current?.focus) inputRef.current?.focus();
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  useMemo(() => {
    if (isTestSms) return;
    if (isEmpty(values[name])) {
      setTempValues([]);
    } else {
      const numberList = _.uniqBy(searchedContact, "value").filter(i => {
        if (values[filterContactBy].includes(i?.value) || values[name].includes(i?.value)) {
          return toJS(i);
        }
      });
      setFieldValue(contactDataField, numberList);
    }
  }, [values?.[name]]);

  useMemo(() => {
    if (isEmpty(value)) setVisible(false);
  }, [value]);

  useEffect(() => {
    if (searchValue) {
      setLoading(true);
      getContactBySearch({ search: searchValue })
        .then(({ data }) => {
          let temp = [];
          if (data.data && data.data.length > 0) {
            temp = data.data.map(i => {
              if (i) {
                return {
                  label: `${i.name} - ${getFormatedContact(i.number)}`,
                  value: getFormatedContact(i.number),
                  number: getFormatedContact(i.number),
                  contactData: {
                    first_name: i.fields?.[0]?.value || "",
                    last_name: i.fields?.[1]?.value || ""
                  }
                };
              }
            });
          }
          if (!isTestSms) {
            setSearchContacts(
              temp && temp.length > 0
                ? temp
                : [
                    {
                      label: getFormatedContact(searchValue),
                      value: getFormatedContact(searchValue),
                      contactData: {
                        first_name: "",
                        last_name: ""
                      }
                    }
                  ]
            );
          }

          temp.splice(0, 0, {
            label: searchValue,
            value: searchValue,
            contactData: {
              first_name: "",
              last_name: ""
            }
          });
          setOptions(temp);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [searchValue]);

  useEffect(() => {
    if (values[name] && values[name].length > 0) {
      if (values[contactDataField] && values[contactDataField].length > 0) {
        setTempValues(values[contactDataField]);
      } else {
        setTempValues(
          values[name].map(i => {
            if (i) {
              return {
                label: getFormatedContact(i),
                value: getFormatedContact(i),
                number: getFormatedContact(i),
                contactData: {
                  first_name: "",
                  last_name: ""
                }
              };
            }
          })
        );
      }
    }
  }, [values[name], values[contactDataField], modalStore.quickSMSContact]);

  const addContact = (option, index) => {
    const value = getFormatedContact(option.value);
    const label = option.label;

    if (value.match(validAusNumberRegExpDeluxe)) {
      if (!isEmpty(values[name]) && values[name]?.includes(value)) return;

      setFieldValue(name, [...values[name], value]);

      let tempItem = {
        label: index === 0 ? value : label,
        value: value,
        number: value,
        contactData: option.contactData || {
          first_name: "",
          last_name: ""
        }
      };

      setTempValues([...tempValues, tempItem]);

      setFieldValue(contactDataField, [...(values[contactDataField] || []), tempItem]);

      setVisible(false);
      setValue("");
    } else {
      setVisible(false);
      setValue("");
    }
  };

  const onPressEnter = event => {
    event.stopPropagation();
    event.preventDefault();

    if (isEmpty(options)) return;

    // Use the first option when pressing enter
    if (options[0]?.value) {
      addContact(options[0], 0);
    }
    return false;
  };

  const removeContact = itemValue => {
    setFieldValue(
      name,
      values[name].filter(i => i !== itemValue)
    );

    setTempValues(tempValues.filter(i => i.value !== itemValue));

    setFieldValue(
      contactDataField,
      (values[contactDataField] || []).filter(i => i.value !== itemValue)
    );

    if (onDeselect) {
      onDeselect(itemValue);
    }
  };

  return (
    <>
      <Popover
        placement="bottomLeft"
        visible={visible}
        id="popover-select-menu"
        autoAdjustOverflow
        getPopupContainer={triggerNode => triggerNode.parentNode}
        content={
          <List
            size="small"
            style={{
              minWidth: "300px",
              overflowY: "scroll",
              maxHeight: "300px"
            }}
            loading={loading}
            dataSource={options}
            renderItem={(item, i) => (
              <List.Item onClick={() => addContact(item, i)} id="popover-select-item" className="pe-auto" type="button">
                {item.label}
              </List.Item>
            )}
          />
        }
        trigger={["click", "hover"]}
      >
        <FormInput
          containerClassname={`mb-2 ${containerClassname}`}
          inputClassname={inputClassname}
          size={size}
          label={label}
          name={name}
          style={inputStyle}
          placeholder={placeholder}
          error={errors[name]}
          touched={touched[name]}
          value={value}
          onChange={e => {
            setVisible(true);
            setValue(e.target.value);
            debouncedSave(e.target.value);
          }}
          inputProps={{
            "data-cy": "contact-selector-input",
            ref: inputRef,
            autoComplete: "off",
            onPressEnter
          }}
          secondary={secondary}
        />
      </Popover>
      <div className="d-flex gap-2 align-items-center flex-wrap">
        {tempValues.map(item => {
          if (item) {
            return (
              <Tag
                key={item?.value}
                closable
                onClose={() => removeContact(item.value)}
                title={item.contactData?.first_name && item.contactData?.last_name ? `${item.contactData.first_name} ${item.contactData.last_name}` : item.value}
              >
                {item.value}
              </Tag>
            );
          }
        })}
      </div>
    </>
  );
};

export default inject(stores => ({
  contactStore: stores.store.contactStore,
  modalStore: stores.store.modalStore
}))(observer(ContactSelector));
